import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-analytics-card',
  templateUrl: './analytics-card.component.html',
  styleUrls: ['./analytics-card.component.scss']
})
export class AnalyticsCardComponent {
  @Input() title = '';
  @Input() exportable = false;
  @Input() infos = '';
  @Input() query?: string;
  @Input() filters?: Record<string, any[]> | null = undefined;
}
